import moment from 'moment-timezone';
/** Gets the next closest quarter of the hour. */
export const getNextQuarter = () => {
    const currentMinute = moment().minute();
    const nextQuarterMinute = currentMinute % 15 === 0
        ? currentMinute + 15
        : Math.ceil(currentMinute / 15) * 15;
    return moment().minute(nextQuarterMinute).second(0);
};
